import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GridStateService {
  private storage = window.sessionStorage;

  setState(key: string, state: any): void {
    this.storage.setItem(`gridState_${key}`, JSON.stringify(state));
  }

  getState(key: string): any {
    const raw = this.storage.getItem(`gridState_${key}`);
    return raw ? JSON.parse(raw) : null;
  }

  clearState(key: string): void {
    this.storage.removeItem(`gridState_${key}`);
  }

  clearAll(): void {
    Object.keys(this.storage)
      .filter(key => key.startsWith('gridState_'))
      .forEach(key => this.storage.removeItem(key));
   
  }

}
